import { render } from "./Beauty.vue?vue&type=template&id=8e6b1d4c"
import script from "./Beauty.vue?vue&type=script&lang=js"
export * from "./Beauty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__